import React, { useContext, useEffect, useState } from "react";
import { Button, Form, FormGroup, FormLabel } from "react-bootstrap";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import { Field, FormikProvider, useFormik } from "formik";
import Shopkeeper from "../../Services/shopkeeperServices";
import Shop from "../../Services/shopServices";
import { AuthContext } from "../../Auth/Context/AuthContext";
import { contractTypeOptions } from "../../Utils/options";
import { SelectField } from "../../Components/InputFormFields";
import { message } from "antd";
import TitleHeader from "../accounts/Components/TitleHeader";
function AddContract(props) {
  const contractId = useParams().id;
  const location = useLocation();
  const [shop, setShop] = useState(location.state?.shop);
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [shops, setShops] = useState([]);
  const [shopkeepers, setShopkeepers] = useState([]);
  const [date, setDate] = useState(
    `${new Date().getFullYear()}-${
      new Date().getMonth() + 1
    }-${new Date().getDate()}`
  );
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      shopkeeperId: [],
      contractType: [],
      note: "",
      shopId: [],
    },
    onSubmit: (values, { setSubmitting, setFieldError }) => {
      // setLoading(true);
      const data = {
        shopkeeperId: values.shopkeeperId?.value,
        shopId: shop?.id || values.shopId?.value,
        contractType: values.contractType?.value,
        note: values?.note,
        contractDate: new Date(date).toISOString(),
        startDate: new Date(startDate).toISOString(),
        endDate: new Date(endDate).toISOString(),
        branchId: user.branchId,
      };
      Shop.addContract(data)
        .then((data) => {
          message.success("Contract Made Successfully");
          setLoading(false);
          navigate("/contract-list");
        })
        .catch((err) => {
          message.error("Contract Not Made");
          setLoading(false);
          console.log(err);
        });
    },
  });
  const { handleSubmit, setFieldValue } = formik;

  const getAllShops = async () => {
    await Shop.getAvailableShops().then((shops) => {
      const updatedData = shops.data?.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setShops(updatedData);
    });
  };

  const getAllShopkeepers = async () => {
    await Shopkeeper.getAll().then((shops) => {
      console.log("Available Free Shopkeepers: ", shops.data);
      const updatedData = shops.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setShopkeepers(updatedData);
    });
  };
  useEffect(() => {
    getAllShops();
    getAllShopkeepers();
  }, []);

  return (
    <>
      {loading && (
        <div id="global-loader">
          <div class="whirly-loader"> </div>
        </div>
      )}
      <div class="page-wrapper">
        <div class="content">
          <TitleHeader title="Create New Contract" />
          {shop && (
            <h3>{`Contract for Shop: F${shop.buildingFloorFloorNumber}-${shop.name}-${shop.shopNumber}`}</h3>
          )}
          <div class="card">
            <div class="card-body">
              <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>
                  <FormGroup className="mb-3">
                    <div class="row">
                      <div class="col-lg-3 col-sm-6 col-12">
                        <SelectField
                          label="Shopkeeper"
                          name="shopkeeperId"
                          options={shopkeepers}
                          onChange={(value) =>
                            setFieldValue("shopkeeperId", value)
                          }
                          searchable={true}
                        />
                      </div>
                      {!shop && (
                        <div class="col-lg-3 col-sm-6 col-12">
                          <SelectField
                            label="Shop"
                            name="shopId"
                            options={shops}
                            onChange={(value) => setFieldValue("shopId", value)}
                            searchable={true}
                          />
                        </div>
                      )}
                      <div class="col-lg-3 col-sm-6 col-12">
                        <SelectField
                          label="Contract Type"
                          name="contractType"
                          options={contractTypeOptions}
                          onChange={(value) =>
                            setFieldValue("contractType", value)
                          }
                          searchable={true}
                        />
                      </div>
                      <div class="col-lg-3 col-sm-6 col-12">
                        <div class="form-group">
                          <FormLabel>Note</FormLabel>
                          <Field
                            type="text"
                            name="note"
                            required
                            placeholder="Note"
                          />
                        </div>
                      </div>
                      <div class="col-lg-3 col-sm-6 col-12">
                        <div class="form-group">
                          <FormLabel>Date</FormLabel>
                          <input
                            className="form-control "
                            name="date"
                            type="date"
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                          />
                        </div>
                      </div>
                      <div class="col-lg-3 col-sm-6 col-12">
                        <div class="form-group">
                          <FormLabel>Contract Start Date</FormLabel>
                          <input
                            className="form-control "
                            name="startDate"
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                          />
                        </div>
                      </div>
                      <div class="col-lg-3 col-sm-6 col-12">
                        <div class="form-group">
                          <FormLabel>Contract End Date</FormLabel>
                          <input
                            className="form-control "
                            name="endDate"
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                          />
                        </div>
                      </div>

                      <div class="col-lg-12">
                        <Button className="btn btn-submit me-2" type="submit">
                          {contractId ? "Update" : "Save"}
                        </Button>
                        <NavLink to="/contract-list" className="btn btn-cancel">
                          Cancel
                        </NavLink>
                      </div>
                    </div>
                  </FormGroup>
                </Form>
              </FormikProvider>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddContract;
